import useMods from '@hooks/useMods';

import logoDark from '@images/logoDark.svg';
import logoLight from '@images/logoLight.svg';
import logoWithoutText from '@images/logoWithoutText.svg';
import Image from 'next/image';

import PropTypes from 'prop-types';
import React from 'react';

const Logo = ({ mods={}, type='withoutText', width, className: classNameTail }) => {
    const { className } = useMods(Logo, { mods });

    return (
        // eslint-disable-next-line @next/next/no-img-element
        <Image
            src={ type === 'light' ? logoLight : type === 'dark' ? logoDark : logoWithoutText }
            className={ className + (classNameTail ? ' ' + classNameTail : '') }
            width={ width }
            alt='Go to the main page'
            unoptimized
        />
    );
};

Logo.displayName = 'Logo';

Logo.propTypes = {
    mods: PropTypes.object,
    type: PropTypes.string,
    width: PropTypes.number
};

export default Logo;
